import logo from './ibisLogo.svg';

export const Logo = logo;
